'use client';

import React from 'react';

import dynamic from 'next/dynamic';

import { withEventScope } from '@repo/event-processor';
import { Spinner } from '@repo/ui-kit/components/core/Spinner';

import MicroAppWrapper from '../shared/MicroAppWrapper/MicroAppWrapper';

import { LoadingWrapper } from './styles';
import { AiVectorGeneratorProps } from './types';

const AiVectorGenerationApp = dynamic(
  () =>
    import(
      'components/AiImageGeneration/TextToImage/AiVectorGenerationApp/AiVectorGenerationApp'
    ),
  {
    ssr: false,
    loading: () => (
      <LoadingWrapper>
        <Spinner size={50} />
      </LoadingWrapper>
    ),
  }
);

const AiVectorGenerator: React.FC<AiVectorGeneratorProps> = (props) => {
  return (
    <MicroAppWrapper
      background={props.background}
      subline={props.subline}
      title={props.title}
    >
      <AiVectorGenerationApp />
    </MicroAppWrapper>
  );
};

export default withEventScope(AiVectorGenerator, {
  feature: 'aiVectorGenerator',
});
